var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h2',[_vm._v("Budget App")]),_c('TotalBalance',{attrs:{"total":_vm.totalBalance}}),_c('div',{staticClass:"wrapper"},[_c('Form'),_c('BudgetList',{attrs:{"list":_vm.filteredList}})],1),_c('Dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }